"use client";

import { useFeatureControl } from "@ctv/core";
import { FC_MWEB } from "@ctv/core/feature-control/constants";
import React from "react";
import withLocationHistory from "../withLocationHistory";

type Props = {
  DesktopComponent: React.JSX.Element;
  MobileComponent: React.JSX.Element;
  excludeFeatureControl?: boolean;
};

export default function WithMwebPageCheck({
  DesktopComponent,
  MobileComponent,
  excludeFeatureControl,
}: Props) {
  const { enabled } = useFeatureControl(FC_MWEB);

  const shouldUseMobile = excludeFeatureControl || enabled;

  return shouldUseMobile
    ? withLocationHistory(MobileComponent)
    : withLocationHistory(DesktopComponent);
}
